import _ from "lodash"
import { dbDateFormatterForGrid, myValueFormatter, myValueFormatter_quantity, myValueFormatterNoFrac, rateFormatter } from "./commonFunctions"
import { TradeStatus } from "./constants"
import TickerHyperLinkComponent from "../components/TickerHyperLinkComponent"

export const supplyManagementGroupByColDef = [
  {
      headerName: 'Availability Id',
      field: 'availability_id',
      minWidth: 80,
      maxWidth: 120,
      hide: true,
      editable: false,
      filter: 'agMultiColumnFilter',
      aggFunc: (params: any) => {
        if (params && params.values && !_.isEmpty(params.values)) {
          return '(' + _.uniq(params.values).length + ')'
        } else {
          return '(0)'
        }
      },
      
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
        borderRight: '0.5px solid #E1E1E1'
      },
      sortable: true
    },
    {
      headerName: 'Lender',
      field: 'lender',
      minWidth: 80,
      maxWidth: 120,
      hide: false,
      editable: false,
      filter: 'agMultiColumnFilter',
      aggFunc: (params: any) => {
        if (params && params.values && !_.isEmpty(params.values)) {
          return '(' + _.uniq(params.values).length + ')'
        } else {
          return '(0)'
        }
      },
      enableRowGroup: true,
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
        borderRight: '0.5px solid #E1E1E1'
      },
      sortable: true
    },
    {
      headerName: 'DTC',
      field: 'dtc',
      minWidth: 70,
      maxWidth: 80,
      aggFunc: (params: any) => {
        if (params && params.values && !_.isEmpty(params.values)) {
          return '(' + _.uniq(params.values).length + ')'
        } else {
          return '(0)'
        }
      },
      editable: false,
      filter: 'agMultiColumnFilter',
      chartDataType: 'category',
      type: 'rightAligned',
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        borderRight: '0.5px solid #E1E1E1'
      },
      sortable: true
    },
    {
      headerName: 'Ticker',
      field: 'ticker',
      minWidth: 73,
      maxWidth: 90,
      enableRowGroup: true,
      rowGroup: true,
      chartDataType: 'category',
      editable: false,
      aggFunc: (params: any) => {
        if (params && params.values && !_.isEmpty(params.values)) {
          return '(' + _.uniq(params.values).length + ')'
        } else {
          return '(0)'
        }
      },
      filter: 'agMultiColumnFilter',
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
        borderRight: '0.5px solid #E1E1E1'
      },
      sortable: true,
      cellRenderer: TickerHyperLinkComponent
    },
    {
      headerName: 'Cusip',
      field: 'cusip',
      minWidth: 85,
      maxWidth: 100,
      chartDataType: 'category',
      editable: false,
      filter: 'agMultiColumnFilter',
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
        borderRight: '0.5px solid #E1E1E1'
      },
      sortable: true
    },
    {
      headerName: 'Qty',
      field: 'qty',
      aggFunc: 'sum',
      sort: 'desc',
      minWidth: 100,
      maxWidth: 130,
      editable: false,
      filter: 'agMultiColumnFilter',
      type: 'rightAligned',
      chartDataType: 'series',
      valueFormatter: myValueFormatter_quantity,
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        borderRight: '0.5px solid #E1E1E1'
      },
      sortable: true
    },
    {
      headerName: 'Rate',
      field: 'rate',
      minWidth: 65,
      maxWidth: 100,
      aggFunc: (params: any) => {
        if (params && params.values && !_.isEmpty(params.values)) {
          if (_.isArray(params.values) && params.values?.length === 1) {
            return params.values[0]
          } else if (_.isArray(params.values) && params.values?.length > 1) {
            return _.mean(params.values)
          }
        } else {
          return 0
        }
      },
      editable: false,
      filter: 'agMultiColumnFilter',
      chartDataType: 'category',
      type: 'rightAligned',
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        borderRight: '0.5px solid #E1E1E1'
      },
      sortable: true,
      valueFormatter:rateFormatter
    },
    {
      headerName: 'Price',
      field: 'price',
      aggFunc: 'avg',
      minWidth: 95,
      maxWidth: 100,
      editable: false,
      filter: 'agMultiColumnFilter',
      chartDataType: 'category',
      type: 'rightAligned',
      valueFormatter: myValueFormatter,
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        borderRight: '0.5px solid #E1E1E1'
      },
      sortable: true
    },
    {
      headerName: 'Value',
      field: 'value',
      aggFunc: 'sum',
      minWidth: 135,
      maxWidth: 200,
      valueFormatter: myValueFormatter,
      editable: false,
      filter: 'agMultiColumnFilter',
      chartDataType: 'category',
      type: 'rightAligned',
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        borderRight: '0.5px solid #E1E1E1'
      },
      sortable: true
    },
    {
      headerName: 'Rec Type',
      field: 'receiveType',
      minWidth: 90,
      maxWidth: 100,
      aggFunc: (params: any) => {
        if (params && params.values && !_.isEmpty(params.values)) return _.max(params.values)
      },
      editable: false,
      filter: 'agMultiColumnFilter',
      chartDataType: 'category',
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
        borderRight: '0.5px solid #E1E1E1'
      },
      sortable: true
    },
    {
      headerName: 'IsReg Sho',
      field: 'isRegshoThreshold',
      minWidth: 100,
      maxWidth: 130,
      cellDataType:'text',
      aggFunc: (params: any) => {
        if (params && params.values && !_.isEmpty(params.values)) {
          if (_.isArray(params.values) && params.values?.length === 1) {
            return params.values[0]
          } else if (_.isArray(params.values) && params.values?.length > 1) {
            return (_.findIndex(params.values, (value:any) => value === 'Yes')>=0)?'Yes':'No'
          }
        } else {
          return 'No'
        }
      },
      editable: false,
      filter: 'agMultiColumnFilter',
      chartDataType: 'category',
      cellStyle: (params: any)=> {
        if(!params?.node?.data?.isTotalRow && params?.node?.data?.isRegshoThreshold === 'Yes'){
          return {
            display: 'flex',
            alignItems: 'center',
            borderRight: '0.5px solid #E1E1E1',
            backgroundColor: TradeStatus.error
          }
        }
        else if(!params?.node?.data?.isTotalRow && params?.node?.aggData?.isRegshoThreshold === 'Yes'){
          return {
            display: 'flex',
            alignItems: 'center',
            borderRight: '0.5px solid #E1E1E1',
            backgroundColor: TradeStatus.error
          }
        }
        else{
          return {
            display: 'flex',
            alignItems: 'center',
            borderRight: '0.5px solid #E1E1E1'
          }
        }
      },
      sortable: true
    },
    {
      headerName: 'Date',
      field: 'updatedTime',
      minWidth: 130,
      maxWidth: 200,
      aggFunc: (params: any) => {
        if (params && params.values && !_.isEmpty(params.values)) return _.max(params.values)
      },
      editable: false,
      filter: 'agSetColumnFilter',
      chartDataType: 'category',
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
        borderRight: '0.5px solid #E1E1E1'
      },
      sortable: true,
      valueFormatter: dbDateFormatterForGrid,
    },
    
  ]

  export const locateSupplyColDef = [
    {
      headerName: 'Lender',
      field: 'lender',
      minWidth: 80,
      maxWidth: 200,
      hide: false,
      editable: false,
      filter: 'agMultiColumnFilter',
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
        borderRight: '0.5px solid #E1E1E1'
      },
      sortable: true
    },
    {
      headerName: 'DTC',
      field: 'dtc',
      minWidth: 70,
      maxWidth: 100,
      aggFunc: (params: any) => {
        if (params && params.values && !_.isEmpty(params.values)) {
          return '(' + _.uniq(params.values).length + ')'
        } else {
          return '(0)'
        }
      },
      editable: false,
      filter: 'agMultiColumnFilter',
      chartDataType: 'category',
      type: 'rightAligned',
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        borderRight: '0.5px solid #E1E1E1'
      },
      sortable: true
    },
    {
      headerName: 'Ticker',
      field: 'ticker',
      minWidth: 70,
      maxWidth: 200,
      chartDataType: 'category',
      editable: false,
      aggFunc: (params: any) => {
        if (params && params.values && !_.isEmpty(params.values)) {
          return '(' + _.uniq(params.values).length + ')'
        } else {
          return '(0)'
        }
      },
      filter: 'agMultiColumnFilter',
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
        borderRight: '0.5px solid #E1E1E1'
      },
      sortable: true
    },
    {
      headerName: 'Cusip',
      field: 'cusip',
      minWidth: 70,
      maxWidth: 200,
      hide:true,
      chartDataType: 'category',
      editable: false,
      filter: 'agMultiColumnFilter',
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
        borderRight: '0.5px solid #E1E1E1'
      },
      sortable: true
    },
    {
      headerName: 'Qty',
      field: 'qty',
      aggFunc: 'sum',
      sort: 'desc',
      minWidth: 100,
      maxWidth: 200,
      editable: false,
      filter: 'agMultiColumnFilter',
      type: 'rightAligned',
      chartDataType: 'series',
      valueFormatter: myValueFormatter_quantity,
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        borderRight: '0.5px solid #E1E1E1'
      },
      sortable: true
    },
    {
      headerName: 'Rate',
      field: 'rate',
      minWidth: 65,
      maxWidth: 200,
      aggFunc: (params: any) => {
        if (params && params.values && !_.isEmpty(params.values)) {
          if (_.isArray(params.values) && params.values?.length === 1) {
            return params.values[0]
          } else if (_.isArray(params.values) && params.values?.length > 1) {
            return _.mean(params.values)
          }
        } else {
          return 0
        }
      },
      editable: false,
      filter: 'agMultiColumnFilter',
      chartDataType: 'category',
      type: 'rightAligned',
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        borderRight: '0.5px solid #E1E1E1'
      },
      sortable: true,
      valueFormatter:rateFormatter
    },
    {
      headerName: 'Price',
      field: 'price',
      aggFunc: 'avg',
      minWidth: 95,
      maxWidth: 130,
      editable: false,
      filter: 'agMultiColumnFilter',
      chartDataType: 'category',
      type: 'rightAligned',
      valueFormatter: myValueFormatter,
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        borderRight: '0.5px solid #E1E1E1'
      },
      sortable: true
    },
    {
      headerName: 'Value',
      field: 'value',
      aggFunc: 'sum',
      minWidth: 135,
      maxWidth: 200,
      valueFormatter: myValueFormatterNoFrac,
      editable: false,
      filter: 'agMultiColumnFilter',
      chartDataType: 'category',
      type: 'rightAligned',
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        borderRight: '0.5px solid #E1E1E1'
      },
      sortable: true
    },
    {
      headerName: 'Rec Type',
      field: 'receiveType',
      minWidth: 90,
      maxWidth: 200,
      aggFunc: (params: any) => {
        if (params && params.values && !_.isEmpty(params.values)) return _.max(params.values)
      },
      editable: false,
      filter: 'agMultiColumnFilter',
      chartDataType: 'category',
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
        borderRight: '0.5px solid #E1E1E1'
      },
      sortable: true
    },
    
    {
      headerName: 'Date',
      field: 'date',
      minWidth: 80,
      maxWidth: 200,
      aggFunc: (params: any) => {
        if (params && params.values && !_.isEmpty(params.values)) return _.max(params.values)
      },
      editable: false,
      filter: 'agSetColumnFilter',
      chartDataType: 'category',
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
        borderRight: '0.5px solid #E1E1E1'
      },
      sortable: true
    }
  ]